var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"selected-number-button",class:{ 'selected-number-button selected': _vm.selected },on:{"click":function($event){return _vm.onClick(_vm.phoneNumber)}}},[_vm._v("\n  "+_vm._s(_vm.number)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }